import { keyMirror } from './data'

export const EVENT_CATEGORIES = keyMirror(
  'FACEBOOK_SHARE_BUTTON',
  'TWITTER_SHARE_BUTTON',
  'WHATSAPP_SHARE_BUTTON',
  'EMAIL_SHARE_BUTTON',
  'PETITION_SIGN_NOW_CTA',
  'FORM'
)

export const EVENT_ACTIONS = keyMirror(
  'CLICK',
  'COMPLETED',
  'NOT_SUBMITTED_AFTER_TIMEOUT',
  'LTT_EMAIL_SENT',
  'PURCHASE'
)
